import type { ScaleBand } from 'd3-scale';

export function getBandCenteredPoint(scale: ScaleBand<string>, v0: string) {
  const point = scale(v0);

  if (point === undefined) {
    return 0;
  }

  return point + scale.bandwidth() / 2;
}
